import {useDev, useAxios, AxiosErrorDataModel} from '@sttedra_ui/framework';
import ConfigurationApiModel from './configuration.api-model';

/**
 * @typedef {import("@sttedra_ui/framework").AxiosErrorDataModel} AxiosErrorDataModel
 */

// #region Globals
const CONTEXT_BASE_PATH = 'Configuration';
const {base} = useAxios();
// #endregion


// #region Public functions
async function getConfigurations() {
  try {
    const url = `/${CONTEXT_BASE_PATH}`;

    const {data} = await base
      .get(url, {
        timeout: 25000,
      });

    return new ConfigurationApiModel(data[0]);
  } catch (err) {
    return catchError(err);
  }
}

// #endregion


// #region Private functions
/**
 *
 * @param {AxiosErrorDataModel} errorModel
 * @returns
 */
function catchError(errorModel) {
  if (!(errorModel instanceof AxiosErrorDataModel)) {
    throw new Error(errorModel);
  }

  useDev.error(
    errorModel.errors
      .reduce((acc, e) => acc + `(${e.code}) ${e.type}: ${e.message}`,
        `[example.api] Errors:\n`),
  );
}
// #endregion

export {
  getConfigurations,
};
